import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
//import {  HashLink as Link } from "react-router-hash-link";
import BecomePatreonFunder from "../../components/BecomePatreonFunderButton"
import logo_img from "src/assets/img/svg/logo.svg"
import github_img from "src/assets/img/svg/github.svg"
import twitter_img from "src/assets/img/svg/twitter-x.svg"
import youtube_img from "src/assets/img/svg/youtube.svg"

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";
const {HashLink: Link} = require("react-router-hash-link");
//const {Link} = HashLink

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    // Extract readable name from image path for alt text
    const altText = src.split('/').pop()?.replace(/\.[^.]+$/, '').replace(/-/g, ' ') || 'Social link';
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={altText}
      >
        <SvgIcon src={src} width="25px" height="25px" alt={`${altText} icon`} />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            {/* <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:support@rillment.games">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col> */}
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large left="true" >
                <Link style={{color: "black"}} to="/tos#top" scroll={(el : any) => el.scrollIntoView({ behavior: 'smooth', block: 'center' })}>{t("Terms of service")}</Link>                
              </Large>
              <Large left="true">
                <Link style={{color: "black"}} to="/privacy#top" scroll={(el :any) => el.scrollIntoView({ behavior: 'smooth', block: 'center' })}>{t("Privacy policy")}</Link>                
              </Large>
              {/* <Large left="true" to="/commissioning">
                {t("Commissioning policy")}
              </Large> */}
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Large left="true">
                <Link style={{color: "black"}} to="/about#top" scroll={(el : any) => el.scrollIntoView({ behavior: 'smooth', block: 'center' })}>{t("About")}</Link>
              </Large>
              {/* <Large left="true" to="/">
                {t("Blog")}
              </Large> */}
              <Large left="true">
                <Link style={{color: "black"}} to="/presskits#top" scroll={(el : any) => el.scrollIntoView({ behavior: 'smooth', block: 'center' })}>{t("Press Kits")}</Link>
              </Large>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              {/* <Empty />
              <Language>{t("Address")}</Language>
              <Para>Rancho Santa Margarita</Para>
              <Para>2131 Elk Street</Para>
              <Para>California</Para> */}
            </Col>

            <Col lg={6} md={6} sm={12} xs={12}>
              {/* <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer> */}
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <Col span={6}>
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src={logo_img}
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            </Col>
            <Col span={12}>
            <FooterContainer>
              {/* <SocialLink
                href="https://github.com/RillmentGames"
                src={github_img}
              /> */}
              <SocialLink
                href="https://twitter.com/RillmentGames"
                src={twitter_img}
              />
              <SocialLink
                href="https://youtube.com/@RillmentGames"
                src={youtube_img}
              /> 
              {/* <a href="https://www.patreon.com/bePatron?u=81967931" data-patreon-widget-type="become-patron-button">Become a Patron!</a> */}
              <BecomePatreonFunder></BecomePatreonFunder>
              
              
            </FooterContainer>
            </Col>
            <Col span={6}>
              {/* spacer */}
            </Col>
          </Row>
        </Container>
      </Extra>
    </>
  )
}

export default withTranslation()(Footer)
// <script async src="https://c6.patreon.com/becomePatronButton.bundle.js"></script>